module.exports = __webpack_public_path__ + "img/epk-photo-1.ab879304.jpeg";